import React, {Fragment} from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';


const Progress = (props) => {
    return (
        <Fragment>
            <CircularProgress  size={50} 
            style={{ 
                    color:"#009390",
                   
                }}
            
            />
        </Fragment>
    )
   
}

export default Progress 


// WEBPACK FOOTER //
// ./src/components/CircularProgress.jsx